<template>
    <Card :title="$t('labels.orderSourceCreate')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.name')" required>
                        <Input v-model="name" />
                    </FormGroup>
                </div>
                <div class="col-lg-3">
                    <FormGroup :label="$t('labels.image')">
                        <ImageInputGroup v-model:image="image" type="order-source" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.color')">
                        <Input v-model="color" type="color" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.integration')">
                        <Autocomplete
                            :url="`/projects/${$route.params.projectUuid}/pim/channels`"
                            :model-value="integration?.uuid"
                            :selected-value="integration?.name"
                            :can-be-empty="true"
                            @update:model-value="integration = $event"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.price_template')">
                        <Autocomplete
                            @update:model-value="priceTemplate = $event"
                            :url="priceTemplatesUrl"
                            :model-value="priceTemplate?.uuid"
                            :selected-value="priceTemplate?.name"
                            :query-params="{ show_in_order: 1 }"
                        />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <Button color="indigo" @click="create">
                <i class="icon-floppy-disk mr-2"></i>
                {{ $t('buttons.create') }}
            </Button>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import Autocomplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import Button from "../../../../components/new/button/AppButton.vue";
import ImageInputGroup from "../../../components/input/ImageInputGroup.vue";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: 'OrderSourceCreatePage',
    components: {
        Card, FormGroup, Input, Autocomplete, Button, ImageInputGroup
    },
    data() {
        return {
            name: '',
            integration: null,
            image: null,
            color: '#000000',
            priceTemplate: null
        }
    },
    computed: {
        priceTemplatesUrl() {
            return `/projects/${this.$route.params.projectUuid}/pim/price-templates`;
        },
    },
    methods: {
        create() {
            let requestData = {
                name: this.name
            };

            if (this.integration) {
                requestData.integration_uuid = this.integration?.uuid;
            }

            if (this.image) {
                requestData.image_file_uuid = this.image.uuid;
            }

            if (this.color) {
                requestData.color = this.color;
            }

            if (this.priceTemplate) {
                requestData.price_template_uuid = this.priceTemplate.uuid;
            }

            httpClient.post(`/projects/${this.$route.params.projectUuid}/crm/sources`, requestData).then((response) => {
                this.$router.push({ name: 'OrderSourceEditPage', params: { orderSourceUuid: response.data.data.uuid } });
            });
        }
    }
}
</script>
